"use client";

import { usePlayerStore } from "@gerama/stores";
import { cn } from "@gerama/utils";

/**
 * Reserves space under the page so the fixed player never covers content. Lives apart from
 * `player-bar.tsx` so the root layout can import it without pulling the player (and hls.js) into the main bundle.
 */
export function PlayerBarSpacer() {
  const hasTrack = usePlayerStore((s) => s.queue.length > 0);
  return <div className={cn(hasTrack ? "h-20 md:h-24" : "h-0")} aria-hidden />;
}
